export default {
  EMPLOYMENT_SITUATION_REPOSITORY: Symbol.for('EMPLOYMENT_SITUATION_REPOSITORY'),
  GET_EMPLOYMENT_SITUATION_QUERY: Symbol.for('GET_EMPLOYMENT_SITUATION_QUERY'),
  EMPLOYMENT_SITUATION_STATE_MANAGER: Symbol.for('EMPLOYMENT_SITUATION_STATE_MANAGER'),
};
